
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Style`}</h1>
<p>{`Never put `}<inlineCode parentName="p">{`/>`}</inlineCode>{` on a new line.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
<Component
  prop="value"
  />

// Good
<Component
  prop="value" />
`}</code></pre>
<p>{`Always favor single line tags when possible.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
<Component
  prop="value">
  Foo
</Component>

// Good
<Component prop="value">
  Foo
</Component>
`}</code></pre>
<p>{`Once a component is split between multiple lines, all props should be split the same way.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
<Component foo="value"
  bar="baz" />

// Good
<Component
  foo="value"
  bar="baz" />
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;